import ScrollItem from './ScrollItem';

import ReadyAnimationWebp from '../img/Ready-animation.webp';
import ReadyAnimation from '../img/Ready-animation.png';
import ReadyImgWebp from '../img/Ready-img.webp';
import ReadyImg from '../img/Ready-img.png';
import ReadyTextWebp from '../img/Ready-text.webp';
import ReadyText from '../img/Ready-text.png';
import ReadyDecorationWebp from '../img/Ready-decoration.webp';
import ReadyDecoration from '../img/Ready-decoration.png';
import './Ready.css';
import './Glitch.css';

export default function Ready() {
    return (
        <section className="Ready" id="about">

            {/*  glitch background  */}
            <div className="glitch">
                <div className="glitch__img img__01"></div>
                <div className="glitch__img img__01"></div>
                <div className="glitch__img img__01"></div>
                <div className="glitch__img img__01"></div>
                <div className="glitch__img img__01"></div>
            </div>

            {/*  roop animation  */}
            <ScrollItem>
                <div className="Ready__animation">
                    <div className="Ready__animation__inner">
                        <div className="Ready__animation__img">
                            <picture>
                                <source type="image/webp" srcSet={ReadyAnimationWebp} />
                                <img src={ReadyAnimation} alt="Ready to rev it up?" />
                            </picture>
                        </div>
                        <div className="Ready__animation__img">
                            <picture>
                                <source type="image/webp" srcSet={ReadyAnimationWebp} />
                                <img src={ReadyAnimation} alt="Ready to rev it up?" />
                            </picture>
                        </div>
                    </div>
                </div>
            </ScrollItem>

            {/*  Ready__flex  */}
            <div className="Ready__flex">
                <div className="Ready__img">
                    <ScrollItem>
                        <div className="glitchPatternInfinite02">
                            <picture>
                                <source type="image/webp" srcSet={ReadyImgWebp} />
                                <img src={ReadyImg} alt="暴走東京" />
                            </picture>
                        </div>
                    </ScrollItem>
                </div>

                <div className="Ready__container">
                    <ScrollItem>
                        <div className="Ready__text">
                            <div>
                                <picture>
                                    <source type="image/webp" srcSet={ReadyTextWebp} />
                                    <img src={ReadyText} alt="Get ready to REV it up.
                                We’re tired of the fakes and the haikus
                                the boring memes and their little inus.
                                We ride the bikes with a violent rage
                                BOSO meaning “I don’t give a shite”.
                                A culture from the BOSO-ZOKU,
                                the gangs with the bikes that don’t give a damn.
                                BOSO NFTs, made in Japan.
                                Meant for the fittest and the Samurai.
                                Get on that bike, and rev it up.
                                Ride to the horizon and the unseen metaverse." />
                                </picture>
                            </div>
                        </div>
                    </ScrollItem>

                    <ScrollItem>
                        <div className="Attention">
                            <p className="Attention__text">
                                Rev your soul.<br className="br--pc" />
                                Rev your engine. Rev your BŌSŌ NFTs.<br className="br--pc" />
                                Staking your BŌSŌ NFTs will passively earn you rewards.<br className="br--pc" />
                                Revving more, earns you more.<br className="br--pc" />
                                Do you hear the sound of a REVolution?
                            </p>
                        </div>
                    </ScrollItem>
                </div>
            </div>

            {/*  Ready decoration  */}
            <div className="Ready__decoration">
                <ScrollItem>
                    <picture>
                        <source type="image/webp" srcSet={ReadyDecorationWebp} />
                        <img src={ReadyDecoration} alt="ドドドドド" />
                    </picture>
                </ScrollItem>
            </div>

            {/*  roop animation  */}
            <ScrollItem>
                <div className="Ready__animation toRight">
                    <div className="Ready__animation__inner">
                        <div className="Ready__animation__img">
                            <picture>
                                <source type="image/webp" srcSet={ReadyAnimationWebp} />
                                <img src={ReadyAnimation} alt="Ready to rev it up?" />
                            </picture>
                        </div>
                        <div className="Ready__animation__img">
                            <picture>
                                <source type="image/webp" srcSet={ReadyAnimationWebp} />
                                <img src={ReadyAnimation} alt="Ready to rev it up?" />
                            </picture>
                        </div>
                    </div>
                </div>
            </ScrollItem>
        </section>
    );
}